<template>
    <div :class="{
        'bg-primary bg-opacity-10': index % 2 == 0,
        'locked-section-soft': balise?.free && balise?.status !== 'TEST',
        'drag-enabled': dragEnabled,
        'dragging-row': isDragging,
        'drop-target-row': isDropTarget
    }" class="card shadow rounded my-4 p-1 py-2 small">
        <div v-if="!updating" class="row d-flex justify-content-between align-items-center">
            <div :class="this.$largeSreen ? 'text-start' : 'd-flex justify-content-center text-center'"
                class="col-lg-4 col-md-5 col-sm-6 mx-1 my-1 locked-gray">
                <div class="ms-3">
                    <VehicleNameDisplay :balise="balise" :showStatuses="true" :linkToMap="true" />
                </div>
            </div>
            <hr class="d-lg-none px-5 my-2" />
            <div class="col-lg-3 col-md-3 col-sm-6 mx-1 d-flex justify-content-center my-1 locked-gray">
                <table class="text-dark text-start table-data">
                    <tr v-if="(isAdmin || isOperator) && (balise.clientName || (balise.client && balise.client.name))">
                        <td class="p-1">
                            <div class="text-muted small">Client</div>
                            <div class="fw-semibold">
                                {{ balise.clientName || (balise.client && balise.client.name) }}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="p-1">
                            <router-link :to="'/balise/' + balise.id" class="btn btn-outline-primary btn-sm action-btn">
                                <font-awesome-icon :icon="['fas', 'circle-info']" class="me-2" />
                                Fiche véhicule
                            </router-link>
                        </td>
                    </tr>
                    <tr>
                        <td class="p-1">
                            <router-link :to="'/drives/' + balise.id"
                                class="btn btn-outline-secondary btn-sm action-btn">
                                <font-awesome-icon :icon="['fas', 'flag-checkered']" class="me-2" />
                                Trajets
                            </router-link>
                        </td>
                    </tr>
                    <tr>
                        <td class="p-1">
                            <router-link :to="'/alerts/' + balise.id"
                                class="btn btn-outline-secondary btn-sm action-btn">
                                <font-awesome-icon :icon="['fas', 'bell']" class="me-2" />
                                Alertes
                            </router-link>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-6 mx-1 my-1 text-center locked-gray">
                <div>{{ balise.lastAddress }}</div>
                <div>
                    <LatLongDisplay :latitude="balise.lastLatitude" :longitude="balise.lastLongitude" />
                </div>
                <div v-if="balise.lastSeen != null" class="mt-1">
                    <LastSeenDisplay :lastSeen="balise.lastSeen" />
                </div>
            </div>
            <div v-if="!this.isOperator && !this.isViewer" class="col-12 col-lg-1 mx-1 me-lg-3 text-center">
                <div v-if="!balise?.free" class="d-none d-lg-block">
                    <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                        <font-awesome-icon :icon="['fas', 'bars']" size="xl" />
                    </a>
                    <div class="dropdown-menu dropdown-menu-end" style="">
                        <router-link :to="'/balise/' + balise.id" class="dropdown-item">Infos détaillées</router-link>
                        <a href="#!" v-on:click="this.updating = true;" class="dropdown-item">Modifier</a>
                        <a href="#!" v-on:click="changeBaliseIcon()" data-bs-toggle="modal" data-bs-target="#iconPicker"
                            class="dropdown-item">Changer l'icône</a>
                    </div>
                </div>
                <div v-else>
                    <span class="text-danger nonfact">NON FACTURABLE</span>
                    <br />
                    <span class="text-muted small nonfact">Appelez votre contact commercial pour activer le
                        service</span>
                </div>
            </div>
        </div>
        <div v-if="updating" class="row d-flex justify-content-between align-items-center">
            <div class="col-md-2 col-sm-6 mx-1 text-center my-1">
                <div class="ms-3">
                    <VehicleNameDisplay :balise="balise" />
                </div>
                <hr class="d-lg-none mx-4" />
            </div>
            <div class="col-md-2 col-sm-6 mx-1 flex-column justify-content-center my-1">
                <span class="text-muted small">Nom :</span>
                <input v-model="newName" type="text" class="form-control" placeholder="Nom">
            </div>
            <div class="col-md-2 col-sm-6 mx-1 flex-column justify-content-center my-1">
                <span class="text-muted small">Groupe :</span>
                <select v-model="newGroupId" class="form-select">
                    <option v-for="group in groups" :key="group.id" :value=group.id>
                        {{ group.name }}
                    </option>
                </select>
            </div>
            <div class="col-md-2 col-sm-6 mx-1 me-3 text-end">
                <ButtonDisplay :type="'save'" @click="this.updating = false; this.updateBalise()" />
                <ButtonDisplay :type="'cancel'" @click="this.updating = false;" />
            </div>
        </div>
    </div>
</template>

<script>
import LastSeenDisplay from '@/components/display/LastSeenDisplay.vue'
import VehicleNameDisplay from '@/components/display/VehicleNameDisplay.vue'
import LatLongDisplay from '@/components/display/LatLongDisplay.vue'
import ButtonDisplay from '@/components/display/ButtonDisplay.vue'
import UserHelper from '@/helpers/user.helper.js'

export default {
    props: ['balise', 'groups', 'index', 'dragEnabled', 'isDragging', 'isDropTarget'],
    components: {
        LatLongDisplay,
        VehicleNameDisplay,
        LastSeenDisplay,
        ButtonDisplay
    },
    data() {
        return {
            updating: false,
            newName: null,
            newGroupId: null
        };
    },
    computed: {
        isAdmin() {
            return UserHelper.isAdmin(this.$store.state.auth.user);
        },
        isViewer() {
            return UserHelper.isViewer(this.$store.state.auth.user);
        },
        isOperator() {
            return UserHelper.isOperator(this.$store.state.auth.user);
        },
    },
    mounted() {
        this.newName = this.balise.name;
        this.newGroupId = this.balise.groupId;
    },
    methods: {
        updateBalise() {
            this.$emit("save", { bId: this.balise.id, name: this.newName, groupId: this.newGroupId });
        },
        changeBaliseIcon() {
            this.$emit("changeIcon", this.balise.id);
        }
    }
}
</script>

<style>
.drag-enabled {
    transition: opacity .12s ease, transform .12s ease, box-shadow .12s ease, outline-color .12s ease;
}

.dragging-row {
    opacity: 0.55;
}

.drop-target-row {
    outline: 2px dashed rgba(13, 110, 253, 0.45);
    outline-offset: 2px;
}

.locked-section-soft {
    position: relative;
    background: rgba(255, 255, 255, 0.35) !important;
    border-radius: .5rem;
}

/* Le badge reste intact */
.locked-section-soft .locked-gray {
    filter: grayscale(1);
    opacity: 0.7;
}

div.dropdown-menu.open {
    position: absolute;
}

.table-data {
    font-size: 1rem;
}

/* Petites “pills” propres et cohérentes avec Bootstrap */
.action-btn {
    border-radius: 50rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    /* même largeur pour tous les liens */
    white-space: nowrap;
    /* pas de retour ligne différent selon libellé */
}

.action-btn:hover {
    transform: translateY(-1px);
    transition: transform .1s ease-in-out;
}

/* Desktop/tablette : on remplit la colonne pour un alignement net */
@media (min-width: 768px) {
    .table-data {
        width: 100%;
    }

    .action-btn {
        width: 100%;
    }
}


/* Empêche l’affichage “une lettre par ligne” en responsive, sans élargir la colonne */
.nonfact {
    white-space: normal;
    /* autorise le retour à la ligne */
    overflow-wrap: anywhere;
    /* coupe si besoin sans déborder */
    word-break: break-word;
    /* fallback pour anciens navigateurs */
    display: inline-block;
    /* pour que max-width s’applique bien */
    max-width: 100%;
    /* ne dépasse jamais la colonne */
    line-height: 1.1;
    /* compacité pour col-1 */
}

@media (min-width: 992px) {

    /* desktop : texte un poil plus petit pour tenir dans col-1 */
    .nonfact {
        font-size: .875rem;
    }
}
</style>